var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideoMuted = function SvgVideoMuted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.526 8.15C20.231 7.967 19.862 7.951 19.553 8.106L17 9.382V8C17 6.897 16.103 6 15 6H6C4.897 6 4 6.897 4 8V16C4 17.103 4.897 18 6 18H15C16.103 18 17 17.103 17 16V14.619L19.553 15.894C19.694 15.965 19.847 16 20 16C20.183 16 20.365 15.95 20.526 15.851C20.82 15.668 21 15.347 21 15V9C21 8.653 20.82 8.332 20.526 8.15ZM14.997 16H6V8H15L14.997 16ZM19 13.382L17 12.382V11.619L19 10.619V13.382Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6777 2.70725C21.0682 3.09777 21.0682 3.73094 20.6777 4.12146L5.12132 19.6778C4.7308 20.0683 4.09763 20.0683 3.70711 19.6778V19.6778C3.31658 19.2873 3.31658 18.6541 3.70711 18.2636L19.2635 2.70725C19.654 2.31672 20.2871 2.31672 20.6777 2.70725V2.70725Z",
    fill: "#EE0606"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoMuted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-muted.a57d3c09.svg";
export { ForwardRef as ReactComponent };